<nav
    class="navbar navbar-expand-lg bg-transparent"
    aria-label="main navigation"
    data-bs-theme="light"
>
    <div class="container-fluid">
        <button
            class="navbar-toggler"
            type="button"
            aria-controls="navigation-links"
            [attr.aria-expanded]="burgerActive"
            aria-label="toggle navigation"
            (click)="toggleBurger()"
            i18n-aria-label
        >
            <span class="navbar-toggler-icon"></span>
        </button>

        <div
            id="navigation-links"
            class="navbar-collapse"
            [ngbCollapse]="!burgerActive"
        >
            <ul class="navbar-nav ms-auto text-secondary">
                @if (!isHomePage()) {
                    <li class="nav-item">
                        <gr-back-to-start-button />
                    </li>
                }
            </ul>
        </div>
    </div>
</nav>
